import classNames from 'classnames';
import React, { Suspense } from 'react';

import Nav from './Nav';
import SkipLink from './SkipLink';

// Dynamic import for code splitting - only loads in dev mode
const DevModeSection = React.lazy(
  (): Promise<{ default: React.ComponentType }> => {
    if (!import.meta.env.VITE_LOCALSTORAGE_AUTH) {
      return Promise.resolve({ default: () => null });
    }
    return import('../DevModeSection');
  },
);

export default function Layout({
  children,
  disable = false,
  hideNav = false,
  DebugInfo,
}: {
  children: React.ReactNode;
  disable?: boolean;
  hideNav?: boolean;
  DebugInfo?: React.FC;
}) {
  if (disable) {
    return children;
  }
  return (
    // layout root
    <div
      className={classNames(
        'ystaii-layout',
        'yst-block',
        'lg:yst-flex lg:yst-min-h-full lg:yst-overflow-visible',
      )}
    >
      <SkipLink>Skip to main content</SkipLink>

      {/* sidebar */}
      {!hideNav && (
        <div
          className={classNames(
            'ystaii-sidebar',
            'yst-overflow-hidden',
            `lg:yst-flex-grow-1 lg:yst-max-w-[300px] lg:yst-flex-shrink-0 lg:yst-basis-[300px] lg:yst-overflow-visible lg:yst-pl-4`,
          )}
        >
          <Nav />
          {DebugInfo && <DebugInfo />}
          <Suspense fallback={null}>
            <DevModeSection />
          </Suspense>
          {/* Only render if DebugInfo is defined */}
          {/* Toast container wrapper - both toast systems render into children of this div */}
          <div
            id="toast-portal"
            className="yst-fixed yst-bottom-4 yst-left-4 yst-w-96 yst-space-y-4"
          >
            <div id="hook-toasts"></div>
            <div id="tsx-toasts"></div>
          </div>
        </div>
      )}

      {/* main */}
      <main
        id="content"
        className={classNames(
          'ystaii-main',
          'yst-mx-4 yst-my-0 yst-flex yst-min-w-0 yst-shrink yst-grow yst-basis-auto yst-px-0 yst-py-6',
          'lg:yst-ml-12 lg:yst-mr-6',
        )}
      >
        {/* TODO: [ ] compare layout with MyYoast */}
        <div
          className={classNames(
            'ystaii-main-content',
            'yst-mx-auto yst-flex yst-flex-col yst-gap-8',
            'lg:yst-w-full lg:yst-flex-row',
          )}
        >
          {/* TODO: [ ] compare layout with MyYoast */}
          <div className="yst-layout-root yst-mx-auto yst-w-full yst-max-w-[1200px] yst-flex-1">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
}
